<template>
  <v-toolbar color="white" light>
    <v-scale-transition>
      <v-btn v-if="!menu" fab small color="primary" bottom left absolute @click="$emit('menu')">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-scale-transition>
    <v-spacer></v-spacer>
    <v-toolbar-title>{{game.name}} - Code : {{game.code}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu bottom transition="slide-y-transition" offset-y :close-on-content-click="false" style="z-index: 99;">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on">
          Actions
        </v-btn>
      </template>
      <v-card>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn v-if="$store.state.games.current.suspended" icon :loading="$store.state.games.loading" @click="pausePlay(false)"><v-icon>play_arrow  </v-icon></v-btn>
              <v-btn v-else icon :loading="$store.state.games.loading" @click="pausePlay(true)"><v-icon>pause</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-title>{{$store.state.games.current.suspended ? $t('inGame.setPlay') : $t('inGame.setPause')}}</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn v-if="$store.state.games.current.status == 2" icon :loading="$store.state.games.loading" @click="startStop(1)"><v-icon>play_arrow  </v-icon></v-btn>
              <v-btn v-else icon :loading="$store.state.games.loading" @click="startStop(2)"><v-icon>stop</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-title>{{$store.state.games.current.status == 2 ? $t('inGame.reopenGame') : $t('inGame.endGame')}}</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile>
            <v-list-tile-action>
              <v-btn v-if="$store.state.games.current.debrief" icon :loading="$store.state.games.loading" @click="debriefOnOff(false)"><v-icon>stop_screen_share  </v-icon></v-btn>
              <v-btn v-else icon :loading="$store.state.games.loading" @click="debriefOnOff(true)"><v-icon>screen_share</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-title>{{$store.state.games.current.suspended ? $t('inGame.debriefOff') : $t('inGame.debriefOn')}}</v-list-tile-title>
          </v-list-tile>
          <v-divider v-if="canBeDeleted" ></v-divider>
          <v-list-tile v-if="canBeDeleted" >
            <v-list-tile-action>
              <v-btn icon :loading="$store.state.games.loading" @click="deleteDialog = true"><v-icon>delete</v-icon></v-btn>
            </v-list-tile-action>
            <v-list-tile-title>{{$t('inGame.delete')}}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('inGame.deleteConfirmation')" :loading="$store.state.games.loading" @confirmation="deleteGame" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-toolbar>
</template>
<script>
import ConfirmationDialog from "@/components/ConfirmationDialog"

export default {
  components: {
    ConfirmationDialog
  },
  props: {
    menu: Boolean,
    game: Object
  },

  data() {
    return {
      deleteDialog: false
    };
  },

  methods: {
    pausePlay (suspended) {
      this.$store.dispatch('games/pausePlayGame', {
        id: this.$store.state.games.current._id,
        data: {
          suspended: suspended
        } 
      })
    },
    startStop (status) {
      this.$store.dispatch('games/startStop', {
        id: this.$store.state.games.current._id,
        data: {
          status: status
        } 
      })
    },
    debriefOnOff (debrief) {
      this.$store.dispatch('games/debriefOnOff', {
        id: this.$store.state.games.current._id,
        data: {
          debrief: debrief
        } 
      })
    },
    async deleteGame () {
      if (await this.$store.dispatch('games/deleteAndRefund', this.$store.state.games.current._id)) {
        this.$router.push('/games')
      }
    }
  },
  computed: {
    canBeDeleted () {
      if (this.$store.state.games.current.params.test) return false
      let ok = true
      for (const company of this.$store.state.games.current.companies) {
        if (company.week > 5) {
          ok = false
        }
      }
      return ok
    }
  }
}
</script>